/* @jsx jsx */
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import VisuallyHidden from '@atlaskit/visually-hidden';
import messages from './messages';
import { useContainerBreakpoints } from '../../hooks/use-container-breakpoints';
import { ErrorButton, ErrorButtonContainer, ErrorMessage, ErrorFloatingContainer } from './error-screen-parts';
export const UnhandledErrorScreen = ({
  onCancel,
  text
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    ref,
    breakpoint
  } = useContainerBreakpoints();
  return jsx(ErrorFloatingContainer, {
    ref: ref,
    breakpoint: breakpoint
  }, jsx(VisuallyHidden, null, formatMessage(messages.ariaErrorTitle)), jsx(ErrorMessage, {
    breakpoint: breakpoint
  }, text), jsx(ErrorButtonContainer, null, jsx(ErrorButton, {
    autoFocus: true,
    testId: 'cancel',
    onClick: onCancel,
    appearance: "primary"
  }, formatMessage(messages.cancelLabel))));
};